/**
 * Configuration for the Salesforce Enhanced Web Chat.
 */
export type EnhancedChatConfig = {
  orgId: string;
  channelName: string; // Developer name of the Enhanced Web Chat deployment
  siteBaseURL: string; // Experience Site URL (for bootstrap)
  scrt2URL: string;
  language?: string; // e.g. 'es' or 'es-ES'
  bootstrapSrc: string; // Full URL to bootstrap.min.js
  maxLoadAttempts?: number;
  retryDelayMs?: number;
  bootstrapReadyTimeoutMs?: number;
};

const PROD_CONFIG: EnhancedChatConfig = {
  orgId: '00D1i000000Um1B',
  channelName: 'VGED_MessagingChannelChatAudi',
  siteBaseURL: 'https://sem-es.my.site.com/ESWVGEDMessagingChannelC1765357441965',
  scrt2URL: 'https://sem-es.my.salesforce-scrt.com',
  language: 'es',
  bootstrapSrc:
    'https://sem-es.my.site.com/ESWVGEDMessagingChannelC1765357441965/assets/js/bootstrap.min.js',
  maxLoadAttempts: 2,
  retryDelayMs: 1500,
  bootstrapReadyTimeoutMs: 8000,
};

const DEV_CONFIG: EnhancedChatConfig = {
  orgId: '00D9O000005vIK8',
  channelName: 'VGED_MessagingChatDeploymentAudi',
  siteBaseURL: 'https://sem-es--dev3.sandbox.my.site.com/ESWVGEDMessagingChannelC1761043714942',
  scrt2URL: 'https://sem-es--dev3.sandbox.my.salesforce-scrt.com',
  language: 'es',
  bootstrapSrc:
    'https://sem-es--dev3.sandbox.my.site.com/ESWVGEDMessagingChannelC1761043714942/assets/js/bootstrap.min.js',
  maxLoadAttempts: 2,
  retryDelayMs: 1500,
  bootstrapReadyTimeoutMs: 8000,
};

export const ENHANCED_CHAT_CONFIG =
  process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEV_CONFIG;
